import React from 'react';
import { Text } from '@wix/wix-base-ui';
import * as symbols from '@wix/santa-editor-symbols';

import * as panels from '#packages/panels';
import { translate } from '#packages/i18n';

const { MessagePanelFrame } = panels.frames;

interface ConcurrentSavePanelFrameProps {
  panelName: string;
  title: string;
  confirmLabel?: string;
  cancelLabel?: string;
  symbolName: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  onClose: () => void;
  onHelp?: () => void;
  hideCloseButton?: boolean;
  closeOnEscPress?: boolean;
  children?: React.ReactNode;
}

export const ConcurrentSavePanelFrame: React.FC<
  ConcurrentSavePanelFrameProps
> = (props) => {
  return (
    <MessagePanelFrame
      isSingleInstance={true}
      className="new-workspace-concurrent-save-panel"
      panelName={props.panelName}
      onConfirm={props.onConfirm}
      onCancel={props.onCancel}
      cancelLabel={translate(props.cancelLabel)}
      confirmLabel={translate(props.confirmLabel)}
      onHelp={props.onHelp}
      title={translate(props.title)}
      illustration={<symbols.symbol name={props.symbolName} />}
      hideCloseButton={props.hideCloseButton}
      cancelOnClickOutside={false}
      cancelOnEscPress={props.closeOnEscPress}
    >
      <Text
        size="medium"
        weight="normal"
        skin="secondary"
        enableEllipsis={false}
        shouldTranslate={false}
      >
        {props.children}
      </Text>
    </MessagePanelFrame>
  );
};
